import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import colors from 'vuetify/lib/util/colors'
import Ripple from 'vuetify/lib/directives/ripple'
import i18n from './i18n'

Vue.use(Vuetify, {
  directives: { Ripple },
})
export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    themes: {
      dark: {
        primary: colors.blue.darken4,
        secondary: colors.grey.darken1,
        accent: colors.shades.black,
        error: colors.red.accent3,
      },
    },
    dark: true,
  },
})
